import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { usePropertyValue } from './usePropertyValue';
import { UrlValidationCache } from '../../validation/validateUrlCache';
export const useValidateUrl = (options = {
  skip: false
}) => {
  const propertyValue = usePropertyValue();
  const httpClient = useHttpClient();
  const getValidateUrl = useCallback(() => {
    return UrlValidationCache.get(propertyValue || '', httpClient);
  }, [httpClient, propertyValue]);
  return useAsyncFunction(getValidateUrl, options);
};